import { Link } from 'react-router-dom';

export const LegalFooter = ({ className = '' }) => {
  return (
    <div className={`flex items-center justify-center gap-3 text-xs text-[#6B7280] ${className}`}>
      <Link 
        to="/privacy" 
        className="hover:text-white transition-colors"
        data-testid="footer-privacy-link"
      >
        Privacy Policy
      </Link>
      <span>|</span>
      <Link 
        to="/terms" 
        className="hover:text-white transition-colors"
        data-testid="footer-terms-link"
      >
        Terms of Service
      </Link>
      <span>|</span>
      <a 
        href="mailto:support@paydaycontrol.app" 
        className="hover:text-white transition-colors"
        data-testid="footer-contact-link"
      >
        Contact
      </a>
    </div>
  );
};

export default LegalFooter;
